<script setup lang="ts">
import { UiCheckbox, UiInfoBox, UiText } from '@shopexperts/shared';

const props = defineProps<{
  fromPath: string;
  toPath: string;
}>();

const createRedirect = defineModel<boolean>({ required: true });
</script>

<template>
  <UiInfoBox variant="warning" title="Page path changed" data-testid="page-path-redirect-notice">
    <div class="flex flex-col gap-2">
      <UiText as="p" variant="p-small">
        Saving moves this page from
        <code class="rounded bg-amber-100 px-1 py-0.5 font-mono text-xs text-amber-900">{{ props.fromPath }}</code>
        to
        <code class="rounded bg-amber-100 px-1 py-0.5 font-mono text-xs text-amber-900">{{ props.toPath }}</code>.
      </UiText>
      <UiCheckbox
        v-model="createRedirect"
        label="Create a permanent redirect (301) from the old path"
      />
    </div>
  </UiInfoBox>
</template>
